import React from 'react';
import { connect } from 'react-redux';
import { withProps, compose } from 'recompose';
import SummaryList from 'components/general/SummaryList/SummaryList';
import MediaSkeleton from 'components/general/Media/MediaSkeleton';
import AlertSummary from 'containers/AlertSummary';
import { selectors } from './../ducks/globalAlerts.duck';

const GlobalAlertsList = compose(
  withProps({
    renderItem: props => (
      <AlertSummary
        {...props}
        small
        event
        hide={['summary', 'image']}
      />
    ),
    renderSkeletonItem: () => (
      <MediaSkeleton horizontal />
    ),
  }),
  connect(state => ({
    items: selectors.inOrder(state),
    loading: selectors.loading(state),
  })),
)(SummaryList);

export default GlobalAlertsList;

